import Swiper from "swiper";
import {
  Pagination,
  Autoplay,
  Navigation,
  EffectCoverflow,
  Thumbs,
  FreeMode,
  Grid, Scrollbar,
} from "swiper/modules";

export class Slider {
  constructor() {
    this._swiperToControl = null;
    this.initSliders();
    this.setupLivewireListeners();
  }

  initSliders() {
    document.querySelectorAll("*[slider]").forEach((slider) => {
      if (slider.swiper) {
        slider.swiper.destroy(true, true);
      }
      this.registerSlider(slider);
    });
  }

  setupLivewireListeners() {
    document.addEventListener("slider:refresh", () => {
      setTimeout(() => {
        this.refreshSliders();
      }, 100);
    });
  }

  refreshSliders() {
    this.initSliders();
  }

  registerSlider(slider) {
    let config = {
      loop: false,
      modules: [],
    };

    /** variables from view **/
    let name = slider.getAttribute("data-slider");
    let per_view = slider.getAttribute("per-view");
    let per_view_sm = slider.getAttribute("per-view-sm");
    let per_view_md = slider.getAttribute("per-view-md");
    let per_view_xs = slider.getAttribute("per-view-xs");
    let modules = slider.getAttribute("modules");

    let parent = "." + slider.closest("section").classList[0];

    let parsedModules = [];
    try {
      parsedModules = JSON.parse(modules);
      if (typeof parsedModules === "string") {
        parsedModules = [parsedModules];
      }
      if (!Array.isArray(parsedModules) && typeof parsedModules === "object") {
        parsedModules = Object.keys(parsedModules).filter(
          (key) => parsedModules[key],
        );
      }
    } catch (e) {
      parsedModules = [];
    }

    /** extra config **/
    const extraConfig = slider.getAttribute("extra");
    let parsedExtraConfig = {};
    if (extraConfig && extraConfig !== "[]") {
      const parsed = JSON.parse(extraConfig);
      if (typeof parsed === "string") {
        parsedExtraConfig = JSON.parse(parsed);
      } else {
        parsedExtraConfig = Array.isArray(parsed) ? parsed[0] || {} : parsed;
      }
    }

    if (parsedModules.includes("navigation")) {
      config.modules.push(Navigation);
      config.navigation = {
        prevEl: parent + " ." + name + "-swiper-button-prev",
        nextEl: parent + " ." + name + "-swiper-button-next",
      };
    }

    if (parsedModules.includes("pagination")) {
      config.modules.push(Pagination);
      config.pagination = {
        el: parent + " .swiper-pagination",
        type: "bullets",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="swiper-pagination-bullet"></span>';
        },
      };
    }

    if (parsedModules.includes("grid")) {
      config.modules.push(Grid);
      config.grid = {
        fill: "column",
        rows: parsedExtraConfig.rows ?? 2,
      };
    }

    if (parsedModules.includes("autoplay")) {
      config.modules.push(Autoplay);
      config.autoplay = {
        delay: 2500,
        disableOnInteraction: false,
        waitForTransition: false,
      };
    }

    if (parsedModules.includes("freeMode")) {
      config.modules.push(FreeMode);
      config.freeMode = true;
    }

    if (parsedModules.includes("coverflow")) {
      config.modules.push(EffectCoverflow);
      config.effect = "coverflow";
      config.centeredSlides = true;
      config.coverflowEffect = {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 4,
        slideShadows: true,
      };
      config.loop = true;
    }

    if (parsedModules.includes("scrollBar")) {
      config.modules.push(Scrollbar);
      config.scrollbar = {
        el: parent + " .swiper-scrollbar",
        hide: false,
        clickable: true,
      }
    }

    const swiper = new Swiper("." + name, {
      ...config,
      ...parsedExtraConfig,
      wrapperClass: name + "-wrapper",
      breakpoints: {
        300: {
          slidesPerView: per_view_xs,
        },
        480: {
          slidesPerView: per_view_sm,
        },
        768: {
          slidesPerView: per_view_md,
        },
        1024: {
          slidesPerView: per_view,
        },
      },
    });

    if (parsedModules.includes("thumbs")) {
      this._swiperToControl = swiper;
    }

    if (parsedExtraConfig.hasThumbs) {
      const updateSwiper = {...this._swiperToControl.params};
      const updateSwiperName =
        this._swiperToControl.el.getAttribute("data-slider");
      this._swiperToControl.destroy(true, true);
      updateSwiper.modules = updateSwiper.modules
        ? [...updateSwiper.modules, Thumbs]
        : [Thumbs];
      updateSwiper.thumbs = {
        swiper: swiper,
      };
      new Swiper("." + updateSwiperName, updateSwiper);
    }

    if (name === "slider--logos") {
    }
  }
}
